import { CardSection } from "container/Manual/components/section/CardSection";
import { Img } from "container/Manual/components/content/Image";
import { Li } from "container/Manual/components/list/Li";
import { ListSection } from "container/Manual/components/section/ListSection";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Ul } from "container/Manual/components/list/Ul";

export const DATE = () => {
  return (
    <CardSection id="DATE" title="DATE">
      <Paragraph>
        세 개의 개별 인수를 가져와 결합하여 새 DateTime 타입 컬럼의 날짜를
        구성합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>DATE(YEAR, MONTH, DATE)</Paragraph>
        <Ul>
          <Li>
            <b>YEAR</b>는 4자리 값입니다.
          </Li>
          <Li>
            <b>MONTH</b>는 2자리 값입니다.
          </Li>
          <Li>
            <b>DATE</b>는 2자리 값입니다.
          </Li>
        </Ul>
      </ListSection>
      <ListSection title="Example">
        <Paragraph accent>DATE(`year`, `month`, `day`)</Paragraph>
        <Img src="computeDate" />
      </ListSection>
      {/* <div>
            <p className="header">Notes on use</p>
            <div className="body">
              <p className="description">
                MONTH 및 DATE의 선행 0은 지원되지 않습니다
                <br />
                예: <p className="highlight inline">DATE(1998,05,08)</p>은{" "}
                <p className="highlight inline">DATE(1998,5,8)</p>과 같이
                표현해야 합니다
              </p>
            </div>
          </div> */}
    </CardSection>
  );
};
